/// <amd-module name="Dashboards/WidgetContractServices/WidgetSizeValidatorService" />

import { WidgetSize } from "Dashboards/Common/Contracts/Dashboard";
import { Services, VssService } from "VSS/Platform/Context";

export class WidgetSizeValidatorService extends VssService {
    /**
     * Returns whether or not the given widget size is valid.
     * @param widgetSize to validate
     * @returns true when the size is valid
     */
    public isValidWidgetSize(widgetSize: WidgetSize): boolean {
        return widgetSize != null && widgetSize.columnSpan > 0 && widgetSize.columnSpan <= 10 && widgetSize.rowSpan > 0 && widgetSize.rowSpan <= 10;
    }
}

Services.add("widget-size-validator-service", { serviceFactory: WidgetSizeValidatorService });
